type ErrorOrigin = "mcp";

export class BaseError extends Error {
  private _hasBeenReportedToSentry = false;
  private _token?: string;
  private _origin?: ErrorOrigin;
  constructor({ message, cause }: { message: string; cause?: Error }) {
    super(message, { cause });
  }

  get hasBeenReportedToSentry(): boolean {
    return this._hasBeenReportedToSentry;
  }
  set hasBeenReportedToSentry(value: boolean) {
    this._hasBeenReportedToSentry = value;
  }

  get token(): string | undefined {
    return this._token;
  }
  set token(value: string | undefined) {
    this._token = value;
  }

  get origin(): ErrorOrigin | undefined {
    return this._origin;
  }
  set origin(value: ErrorOrigin | undefined) {
    this._origin = value;
  }
}
